module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('row', [_c('div', {
    staticClass: "col s12"
  }, [_c('markdown-card', {
    attrs: {
      "url": "content/Suggestion.txt"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00e66cc7!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/Guideline.vue
// module id = 67
// module chunks = 0